import React, { useState } from "react"

import { gql, useQuery } from "hooks/urql"

import Checkbox from "components/Forms/Checkbox"
import LocalTime from "components/LocalTime"
import Pagination from "components/Pagination"
import UrqlLoadingIndicator from "components/WithLoadingIndicator/urql"

const PackageStudents = () => {
  const [studentPage, setStudentPage] = useState(1)
  const [zeroBalanceOnly, setZeroBalanceOnly] = useState(false)
  const [lowBalanceOnly, setLowBalanceOnly] = useState(false)

  const [result] = useQuery({
    query: packageParentsQuery,
    variables: { studentPage, zeroBalanceOnly, lowBalanceOnly },
  })

  return (
    <UrqlLoadingIndicator result={result}>
      {({ data: { packageStudents } }) => (
        <>
          <div className="mb-2 flex gap-6 ">
            <Checkbox
              name="zeroBalanceOnly"
              value={zeroBalanceOnly}
              checked={zeroBalanceOnly}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setLowBalanceOnly(false)
                setZeroBalanceOnly(e.target.checked)
              }}
            >
              Zero Balance Only
            </Checkbox>
            <Checkbox
              name="lowBalanceOnly"
              value={lowBalanceOnly}
              checked={lowBalanceOnly}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setZeroBalanceOnly(false)
                setLowBalanceOnly(e.target.checked)
              }}
            >
              Low Balance Only
            </Checkbox>
          </div>

          <table className="table">
            <thead className="text-primary">
              <tr>
                <th>Student Info</th>
                <th>Subjects</th>
                <th>Matched Tutors</th>
                <th>Prepaid Hours Balance</th>
                <th>Last Package Purchased</th>
              </tr>
            </thead>
            <tbody>
              {packageStudents.data.map(student => (
                <tr key={student.id}>
                  <td>
                    <div>
                      <a
                        href={student.showPath}
                        className="font-semibold"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {student.fullName}
                      </a>
                      <div>
                        {student.grade?.name}{" "}
                        {student.school && `at ${student.school.name}`}
                      </div>
                      <div>
                        {student.foreignLanguages
                          .map(lang => lang.name)
                          .join(", ")}
                      </div>
                    </div>
                  </td>
                  <td>
                    {student.subjects.map(subject => subject.name).join(", ")}
                  </td>
                  <td>
                    {student.matchedUsers.data.map((tutor, idx) => (
                      <span key={tutor.id}>
                        <a
                          href={tutor.showPath}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {tutor.fullName}
                        </a>
                        {idx < student.matchedUsers.data.length - 1 && ", "}
                      </span>
                    ))}
                  </td>
                  <td>{student.prepaidHours}</td>
                  <td>
                    <LocalTime
                      omitTime
                      timestamp={student.lastPackagePurchased}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <Pagination
            totalPages={packageStudents.totalPages}
            currentPage={packageStudents.currentPage}
            changePage={setStudentPage}
          />
        </>
      )}
    </UrqlLoadingIndicator>
  )
}

const packageParentsQuery = gql`
  query PackageParentsQuery(
    $studentPage: Int!
    $zeroBalanceOnly: Boolean
    $lowBalanceOnly: Boolean
  ) {
    packageStudents(
      page: $studentPage
      zeroBalanceOnly: $zeroBalanceOnly
      lowBalanceOnly: $lowBalanceOnly
    ) {
      totalPages
      currentPage
      data {
        id
        type
        showPath
        fullName
        prepaidHours
        lastPackagePurchased
        grade {
          id
          name
        }
        foreignLanguages {
          id
          name
        }
        school {
          id
          showPath
          name
        }
        subjects {
          id
          name
        }
        matchedUsers {
          data {
            id
            fullName
            showPath
          }
        }
      }
    }
  }
`

export default PackageStudents
